import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type { WebhookConfigDetail } from '@mangovoice/types'

import type { ApiError } from '../api/types'
import type { WebhooksApi } from '../api/webhooksApi'

interface UseGetIntegrationParams {
  api: WebhooksApi
  pbxId: number
  integrationId: number
  options?: Omit<
    UseQueryOptions<WebhookConfigDetail, ApiError>,
    'queryKey' | 'queryFn'
  >
}

export const useGetIntegration = ({
  api,
  pbxId,
  integrationId,
  options,
}: UseGetIntegrationParams): UseQueryResult<WebhookConfigDetail, ApiError> => {
  return useQuery<WebhookConfigDetail, ApiError>({
    queryKey: ['webhook', pbxId, integrationId],
    queryFn: async () => {
      const response = await api.getWebhookDetail(pbxId, integrationId)

      if (!response.ok) {
        return Promise.reject(response.data as ApiError)
      }

      return response.data!
    },
    enabled: pbxId > 0 && integrationId > 0,
    ...options,
    retry: options?.retry ?? false,
  })
}
